import styled from 'styled-components';
import { Button } from '@lendi-ui/button';
import { ValidHex } from '@lendi-ui/commons/colours';

export const ClearButton = styled(Button)<{ textColor?: ValidHex }>`
  background-color: transparent !important;
  color: ${(props) => props.textColor};
`;
